// import React from "react";
import React from "react";
import contact_background from "../Images/Contact/top_background.webp";
import "../Stylesheets/Contact.css";
import Navbar from "../Components/Common/Navbar";
import Footer from "../Pages/Footer.js";
import { Link } from "react-router-dom";
import "../index.css";
// import gmail from "../Images/Contact/gmail.png";
// import Breadcrumbs from "../Components/Common/Breadcrumbs";
import Hero from "../Components/Common/Hero.js";

function ContactUs() {
  return (
    <>
      <div className="min-vh-100">
        <Navbar />
        <br />
        <br />
        <br />

        <Hero title="Contact" img={contact_background} 
        creatorLink="https://unsplash.com/@pawel_czerwinski?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
        creator="Pawel Czerwinski"
        imageLink="https://unsplash.com/photos/a-close-up-of-a-cell-phone-with-a-blurry-background-6YutWe6awpM?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
        source="Unsplash"
        />

        {/* <Breadcrumbs /> */}

        <div className="contaner-fluid">
          <div className="container">
            <h4
              class
              className="text-break text-center my-5 pt-2 fw-bold heading-font-size"
            >
              We would love to hear from you
            </h4>

            <div className="ratio ratio-21x9 mb-5">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3053.4548482340488!2d75.12109009726986!3d15.370411689177645!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb8d14ba920f7c9%3A0x9ec0ab31cd15ee5!2sKLE%20Tech.%20Samsung%20SEED%20(Student%20Eco-system%20for%20Engineered%20Data)%20Lab%2C%20CEVI%20(Center%20of%20Excellence%20in%20Visual%20Intelligence)!5e0!3m2!1sen!2sin!4v1726034792368!5m2!1sen!2sin"
                allowfullscreen=""
                loading="lazy"
                title="YouTube video player"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>

            <div className="row pt-5">
              <div className="col-12 col-sm-6 order-2 order-sm-1 text-center ">
                <h6 className="fw-bold heading-font-size">Contact Us</h6>
                <Link
                  to="tel: +91-8362378410"
                  style={{ color: "black" }}
                  className="text-decoration-none"
                >
                  <p className="content-font-size me-4 mb-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      >
                {/* <!--! Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2024 Fonticons, Inc. --> */}
                      <path
                        d="M21 16.42V19.956C21.0001 20.2092 20.9042 20.453 20.7316 20.6382C20.559 20.8234 20.3226 20.9363 20.07 20.954C19.633 20.984 19.276 21 19 21C10.163 21 3 13.837 3 5C3 4.724 3.015 4.367 3.046 3.93C3.06372 3.67744 3.17658 3.44101 3.3618 3.26841C3.54703 3.09581 3.79082 2.99989 4.044 3H7.58C7.70404 2.99987 7.8237 3.04586 7.91573 3.12902C8.00776 3.21218 8.0656 3.32658 8.078 3.45C8.101 3.68 8.122 3.863 8.142 4.002C8.34073 5.38892 8.748 6.73783 9.35 8.003C9.445 8.203 9.383 8.442 9.203 8.57L7.045 10.112C8.36445 13.1865 10.8145 15.6365 13.889 16.956L15.429 14.802C15.4919 14.714 15.5838 14.6509 15.6885 14.6237C15.7932 14.5964 15.9042 14.6068 16.002 14.653C17.267 15.2539 18.6156 15.6601 20.002 15.858C20.141 15.878 20.324 15.9 20.552 15.922C20.6752 15.9346 20.7894 15.9926 20.8724 16.0846C20.9553 16.1766 21.0012 16.2961 21.001 16.42H21Z"
                        fill="#001018"
                      />
                    </svg>
                    +91 8362378410
                  </p>
                </Link>
                <Link
                  to="mailto: cevi@kletech.ac.in"
                  style={{ color: "black" }}
                  className="text-decoration-none"
                >
                  <p className="content-font-size">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      className="me-1"
                      >
                {/* <!--! Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2024 Fonticons, Inc. --> */}
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M21 3H3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V4C22 3.44772 21.5523 3 21 3ZM5.648 6.238L12.06 11.683H12.061L18.346 6.244L19.654 7.757L12.073 14.317L4.353 7.762L5.648 6.238Z"
                        fill="#001018"
                      />
                    </svg>
                    cevi@kletech.ac.in
                  </p>
                </Link>

                {/* instagram icon */}
                {/* <Link
                  to="https://www.instagram.com/kletech_cevi?igsh=cm01czB0qGc1ZDJo"
                  style={{ color: "black" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="26"
                    height="26"
                    viewBox="0 0 48 48"
                    fill="none"
                    className="me-2"
                  >
                    <path
                      d="M16.0019 24C16.0019 19.5819 19.5827 15.9994 24.001 15.9994C28.4192 15.9994 32.0019 19.5819 32.0019 24C32.0019 28.4181 28.4192 32.0006 24.001 32.0006C19.5827 32.0006 16.0019 28.4181 16.0019 24ZM11.6768 24C11.6768 30.8064 17.1943 36.3237 24.001 36.3237C30.8076 36.3237 36.3252 30.8064 36.3252 24C36.3252 17.1936 30.8076 11.6763 24.001 11.6763C17.1943 11.6763 11.6768 17.1936 11.6768 24ZM33.9329 11.1876C33.9327 11.7573 34.1014 12.3141 34.4177 12.7879C34.734 13.2616 35.1836 13.6309 35.7098 13.8491C36.236 14.0673 36.8151 14.1246 37.3738 14.0137C37.9325 13.9028 38.4458 13.6287 38.8488 13.2261C39.2517 12.8235 39.5263 12.3104 39.6376 11.7518C39.749 11.1932 39.6922 10.6141 39.4744 10.0877C39.2566 9.5614 38.8876 9.11146 38.4141 8.79481C37.9406 8.47816 37.3838 8.30903 36.8142 8.3088H36.8131C36.0495 8.30916 35.3173 8.61254 34.7773 9.15232C34.2373 9.6921 33.9336 10.4241 33.9329 11.1876ZM14.3046 43.5354C11.9646 43.4289 10.6927 43.0391 9.8475 42.7098C8.72694 42.2736 7.92742 41.7541 7.08681 40.9146C6.2462 40.0752 5.72586 39.2765 5.29154 38.156C4.96205 37.3112 4.57228 36.039 4.46591 33.6991C4.34955 31.1693 4.32632 30.4093 4.32632 24.0002C4.32632 17.591 4.35147 16.8332 4.46591 14.3013C4.57247 11.9614 4.96513 10.6917 5.29154 9.84442C5.72778 8.7239 6.24735 7.92442 7.08681 7.08384C7.92627 6.24326 8.72502 5.72294 9.8475 5.28864C10.6923 4.95917 11.9646 4.56941 14.3046 4.46304C16.8345 4.34669 17.5944 4.32346 24.001 4.32346C30.4075 4.32346 31.1682 4.34861 33.7002 4.46304C36.0402 4.5696 37.31 4.96224 38.1573 5.28864C39.2779 5.72294 40.0774 6.24442 40.918 7.08384C41.7586 7.92326 42.277 8.7239 42.7133 9.84442C43.0427 10.6892 43.4325 11.9614 43.5389 14.3013C43.6553 16.8332 43.6785 17.591 43.6785 24.0002C43.6785 30.4093 43.6553 31.1672 43.5389 33.6991C43.4323 36.039 43.0406 37.3108 42.7133 38.156C42.277 39.2765 41.7574 40.076 40.918 40.9146C40.0785 41.7533 39.2779 42.2736 38.1573 42.7098C37.3125 43.0393 36.0402 43.4291 33.7002 43.5354C31.1703 43.6518 30.4104 43.675 24.001 43.675C17.5916 43.675 16.8337 43.6518 14.3046 43.5354ZM14.1058 0.145344C11.5508 0.261696 9.80487 0.666816 8.28014 1.2601C6.70107 1.87277 5.36431 2.69472 4.02851 4.02835C2.69272 5.36198 1.87284 6.7008 1.26015 8.27981C0.666843 9.80544 0.261706 11.5503 0.14535 14.1053C0.0270731 16.6643 0 17.4824 0 24C0 30.5176 0.0270731 31.3357 0.14535 33.8947C0.261706 36.4499 0.666843 38.1946 1.26015 39.7202C1.87284 41.2982 2.69291 42.6386 4.02851 43.9716C5.36412 45.3047 6.70107 46.1255 8.28014 46.7399C9.80775 47.3332 11.5508 47.7383 14.1058 47.8547C16.6663 47.971 17.4831 48 24.001 48C30.5189 48 31.337 47.9729 33.8961 47.8547C36.4513 47.7383 38.1961 47.3332 39.7218 46.7399C41.2999 46.1255 42.6376 45.3053 43.9734 43.9716C45.3092 42.638 46.1274 41.2982 46.7418 39.7202C47.3351 38.1946 47.7421 36.4497 47.8566 33.8947C47.9729 31.3338 48 30.5176 48 24C48 17.4824 47.9729 16.6643 47.8566 14.1053C47.7402 11.5501 47.3351 9.80448 46.7418 8.27981C46.1274 6.70176 45.3071 5.3641 43.9734 4.02835C42.6397 2.69261 41.2999 1.87277 39.7237 1.2601C38.1961 0.666816 36.4511 0.259776 33.898 0.145344C31.3389 0.028992 30.5208 0 24.0029 0C17.485 0 16.6663 0.027072 14.1058 0.145344Z"
                      fill="url(#paint0_radial_866_6444)"
                    />
                    <path
                      d="M16.0019 24C16.0019 19.5819 19.5827 15.9994 24.001 15.9994C28.4192 15.9994 32.0019 19.5819 32.0019 24C32.0019 28.4181 28.4192 32.0006 24.001 32.0006C19.5827 32.0006 16.0019 28.4181 16.0019 24ZM11.6768 24C11.6768 30.8064 17.1943 36.3237 24.001 36.3237C30.8076 36.3237 36.3252 30.8064 36.3252 24C36.3252 17.1936 30.8076 11.6763 24.001 11.6763C17.1943 11.6763 11.6768 17.1936 11.6768 24ZM33.9329 11.1876C33.9327 11.7573 34.1014 12.3141 34.4177 12.7879C34.734 13.2616 35.1836 13.6309 35.7098 13.8491C36.236 14.0673 36.8151 14.1246 37.3738 14.0137C37.9325 13.9028 38.4458 13.6287 38.8488 13.2261C39.2517 12.8235 39.5263 12.3104 39.6376 11.7518C39.749 11.1932 39.6922 10.6141 39.4744 10.0877C39.2566 9.5614 38.8876 9.11146 38.4141 8.79481C37.9406 8.47816 37.3838 8.30903 36.8142 8.3088H36.8131C36.0495 8.30916 35.3173 8.61254 34.7773 9.15232C34.2373 9.6921 33.9336 10.4241 33.9329 11.1876ZM14.3046 43.5354C11.9646 43.4289 10.6927 43.0391 9.8475 42.7098C8.72694 42.2736 7.92742 41.7541 7.08681 40.9146C6.2462 40.0752 5.72586 39.2765 5.29154 38.156C4.96205 37.3112 4.57228 36.039 4.46591 33.6991C4.34955 31.1693 4.32632 30.4093 4.32632 24.0002C4.32632 17.591 4.35147 16.8332 4.46591 14.3013C4.57247 11.9614 4.96513 10.6917 5.29154 9.84442C5.72778 8.7239 6.24735 7.92442 7.08681 7.08384C7.92627 6.24326 8.72502 5.72294 9.8475 5.28864C10.6923 4.95917 11.9646 4.56941 14.3046 4.46304C16.8345 4.34669 17.5944 4.32346 24.001 4.32346C30.4075 4.32346 31.1682 4.34861 33.7002 4.46304C36.0402 4.5696 37.31 4.96224 38.1573 5.28864C39.2779 5.72294 40.0774 6.24442 40.918 7.08384C41.7586 7.92326 42.277 8.7239 42.7133 9.84442C43.0427 10.6892 43.4325 11.9614 43.5389 14.3013C43.6553 16.8332 43.6785 17.591 43.6785 24.0002C43.6785 30.4093 43.6553 31.1672 43.5389 33.6991C43.4323 36.039 43.0406 37.3108 42.7133 38.156C42.277 39.2765 41.7574 40.076 40.918 40.9146C40.0785 41.7533 39.2779 42.2736 38.1573 42.7098C37.3125 43.0393 36.0402 43.4291 33.7002 43.5354C31.1703 43.6518 30.4104 43.675 24.001 43.675C17.5916 43.675 16.8337 43.6518 14.3046 43.5354ZM14.1058 0.145344C11.5508 0.261696 9.80487 0.666816 8.28014 1.2601C6.70107 1.87277 5.36431 2.69472 4.02851 4.02835C2.69272 5.36198 1.87284 6.7008 1.26015 8.27981C0.666843 9.80544 0.261706 11.5503 0.14535 14.1053C0.0270731 16.6643 0 17.4824 0 24C0 30.5176 0.0270731 31.3357 0.14535 33.8947C0.261706 36.4499 0.666843 38.1946 1.26015 39.7202C1.87284 41.2982 2.69291 42.6386 4.02851 43.9716C5.36412 45.3047 6.70107 46.1255 8.28014 46.7399C9.80775 47.3332 11.5508 47.7383 14.1058 47.8547C16.6663 47.971 17.4831 48 24.001 48C30.5189 48 31.337 47.9729 33.8961 47.8547C36.4513 47.7383 38.1961 47.3332 39.7218 46.7399C41.2999 46.1255 42.6376 45.3053 43.9734 43.9716C45.3092 42.638 46.1274 41.2982 46.7418 39.7202C47.3351 38.1946 47.7421 36.4497 47.8566 33.8947C47.9729 31.3338 48 30.5176 48 24C48 17.4824 47.9729 16.6643 47.8566 14.1053C47.7402 11.5501 47.3351 9.80448 46.7418 8.27981C46.1274 6.70176 45.3071 5.3641 43.9734 4.02835C42.6397 2.69261 41.2999 1.87277 39.7237 1.2601C38.1961 0.666816 36.4511 0.259776 33.898 0.145344C31.3389 0.028992 30.5208 0 24.0029 0C17.485 0 16.6663 0.027072 14.1058 0.145344Z"
                      fill="url(#paint1_radial_866_6444)"
                    />
                    <defs>
                      <radialGradient
                        id="paint0_radial_866_6444"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(6.37734 48.2268) scale(62.6625 62.66)"
                      >
                        <stop offset="0.09" stop-color="#FA8F21" />
                        <stop offset="0.78" stop-color="#D82D7E" />
                      </radialGradient>
                      <radialGradient
                        id="paint1_radial_866_6444"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(29.1111 50.3772) scale(49.3867 49.3847)"
                      >
                        <stop
                          offset="0.64"
                          stop-color="#8C3AAA"
                          stop-opacity="0"
                        />
                        <stop offset="1" stop-color="#8C3AAA" />
                      </radialGradient>
                    </defs>
                  </svg>
                </Link> */}

                {/* twitter(X) icon */}
                {/* <Link
                  to="https://x.com/kletech_cevi"
                  style={{ color: "black" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="26"
                    height="26"
                    viewBox="0 0 48 48"
                    fill="none"
                    className="ms-1 me-2"
                  >
                    <path
                      d="M36.6526 3.80859H43.3995L28.6594 20.6556L46 43.5805H32.4225L21.7881 29.6767L9.61989 43.5805H2.86886L18.6349 25.5608L2 3.80859H15.9222L25.5348 16.5173L36.6526 3.80859ZM34.2846 39.5422H38.0232L13.8908 7.63486H9.87892L34.2846 39.5422Z"
                      fill="black"
                    />
                  </svg>
                </Link> */}

                {/* linkedin icon */}
                {/* <Link
                  to="https://www.linkedin.com/company/kletech-center-of-excellence-in-visual-intelligence-cevi"
                  style={{ color: "black" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="26"
                    height="26"
                    viewBox="0 0 48 48"
                    fill="none"
                    className="ms-1 me-2"
                  >
                    <g clip-path="url(#clip0_866_6447)">
                      <path
                        d="M44.4567 0H3.54333C2.60358 0 1.70232 0.373315 1.03782 1.03782C0.373315 1.70232 0 2.60358 0 3.54333V44.4567C0 45.3964 0.373315 46.2977 1.03782 46.9622C1.70232 47.6267 2.60358 48 3.54333 48H44.4567C45.3964 48 46.2977 47.6267 46.9622 46.9622C47.6267 46.2977 48 45.3964 48 44.4567V3.54333C48 2.60358 47.6267 1.70232 46.9622 1.03782C46.2977 0.373315 45.3964 0 44.4567 0ZM14.3067 40.89H7.09V17.9667H14.3067V40.89ZM10.6933 14.79C9.87473 14.7854 9.07583 14.5384 8.39747 14.0802C7.71911 13.622 7.19168 12.9731 6.88175 12.2154C6.57183 11.4577 6.4933 10.6252 6.65606 9.82291C6.81883 9.02063 7.2156 8.28455 7.79631 7.70756C8.37702 7.13057 9.11563 6.73853 9.91893 6.58092C10.7222 6.42331 11.5542 6.50719 12.3099 6.82197C13.0656 7.13675 13.7111 7.66833 14.1649 8.34962C14.6188 9.03092 14.8606 9.83138 14.86 10.65C14.8677 11.1981 14.765 11.7421 14.558 12.2496C14.351 12.7571 14.044 13.2178 13.6551 13.6041C13.2663 13.9905 12.8037 14.2946 12.2948 14.4983C11.786 14.702 11.2413 14.8012 10.6933 14.79ZM40.9067 40.91H33.6933V28.3867C33.6933 24.6933 32.1233 23.5533 30.0967 23.5533C27.9567 23.5533 25.8567 25.1667 25.8567 28.48V40.91H18.64V17.9833H25.58V21.16H25.6733C26.37 19.75 28.81 17.34 32.5333 17.34C36.56 17.34 40.91 19.73 40.91 26.73L40.9067 40.91Z"
                        fill="#0A66C2"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_866_6447">
                        <rect width="48" height="48" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </Link> */}

                {/* Github logo */}

                {/* <Link
                  to="https://github.com/CeviKle"
                  style={{ color: "black" }}
                  className="mx-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="26"
                    height="26"
                    fill="currentColor"
                    viewBox="0 0 496 512"
                  >
                    <path d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3 .3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5 .3-6.2 2.3zm44.2-1.7c-2.9 .7-4.9 2.6-4.6 4.9 .3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3 .7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3 .3 2.9 2.3 3.9 1.6 1 3.6 .7 4.3-.7 .7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3 .7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3 .7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z" />
                  </svg>
                </Link> */}

                {/* youtube icon */}

                {/*<Link
                  to="https://www.youtube.com/@cevicenterofexcellenceinvi6081"
                  style={{ color: "black" }}
                  className="text-decoration-none"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 48 48"
                    fill="none"
                    className="mx-2"
                  >
                    <g clip-path="url(#clip0_866_6443)">
                      <path
                        d="M47.0432 12.3698C46.7719 11.3487 46.237 10.4167 45.4923 9.66716C44.7476 8.91763 43.819 8.37685 42.7996 8.09893C39.0469 7.08984 24.0469 7.08984 24.0469 7.08984C24.0469 7.08984 9.04688 7.08984 5.29415 8.09893C4.27474 8.37685 3.34619 8.91763 2.60145 9.66716C1.85671 10.4167 1.32189 11.3487 1.05051 12.3698C0.0468751 16.1389 0.046875 23.9989 0.046875 23.9989C0.046875 23.9989 0.0468751 31.8589 1.05051 35.628C1.32189 36.6492 1.85671 37.5812 2.60145 38.3307C3.34619 39.0802 4.27474 39.621 5.29415 39.8989C9.04688 40.908 24.0469 40.908 24.0469 40.908C24.0469 40.908 39.0469 40.908 42.7996 39.8989C43.819 39.621 44.7476 39.0802 45.4923 38.3307C46.237 37.5812 46.7719 36.6492 47.0432 35.628C48.0469 31.8589 48.0469 23.9989 48.0469 23.9989C48.0469 23.9989 48.0469 16.1389 47.0432 12.3698Z"
                        fill="#FF0302"
                      />
                      <path
                        d="M19.1387 31.1378V16.8633L31.6841 24.0006L19.1387 31.1378Z"
                        fill="#FEFEFE"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_866_6443">
                        <rect width="48" height="48" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </Link> */}

                {/* Mail Icon */}

                {/* <Link to="mailto:mailto:cevi@kletech.ac.in">
                  <img src={gmail} height="26" width="26" className="ms-1" alt="gmail"/>
                </Link> */}
              </div>
              <div className="col-12 col-sm-6 order-1 order-sm-2 text-center">
                <h6 className="fw-bold heading-font-size">Visit Us</h6>
                <p className="text-break content-font-size">
                  Center for Visual Intelligence (CEVI) <br />
                  2nd floor, C-Lite building, KLE Tech university,
                  <br />
                  BVB Campus, vidyanagar Hubballi 580031,
                  <br /> Karnataka India.
                </p>
              </div>
            </div>
          </div>
        </div>
        <br />
        <br />

        <Footer />
      </div>
    </>
  );
}

export default ContactUs;
